var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowcasePage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1902 2.04134L5.53822 5.88529C4.6483 6.28082 4.06738 7.17074 4.06738 8.14718V13.9564C4.06738 20.8162 8.81362 27.231 15.1914 28.7884C21.5691 27.231 26.3154 20.8162 26.3154 13.9564V8.14718C26.3154 7.17074 25.7345 6.28082 24.8445 5.88529L16.1925 2.04134C15.5622 1.75705 14.8206 1.75705 14.1902 2.04134ZM15.1914 15.18H23.8434C23.1883 20.2723 19.7893 24.8085 15.1914 26.2299V15.1924H6.53938V8.14718L15.1914 4.30322V15.18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcasePage1);
export default __webpack_public_path__ + "static/media/ShowcasePage1.a2a48838e818e446db5bab1bd6b4bb0d.svg";
export { ForwardRef as ReactComponent };